"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.function.name.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _client = require("@apollo/client");

var _LoadingOutlined = _interopRequireDefault(require("@ant-design/icons/LoadingOutlined"));

var _spin = _interopRequireDefault(require("antd/lib/spin"));

var _AdTrack = _interopRequireDefault(require("@meepshop/context/lib/AdTrack"));

var _filter = _interopRequireDefault(require("@meepshop/utils/lib/filter"));

var _Head = _interopRequireDefault(require("./Head"));

var _useFbq = _interopRequireDefault(require("./hooks/useFbq"));

var _useRetention = _interopRequireDefault(require("./hooks/useRetention"));

var _useCustom = _interopRequireDefault(require("./hooks/useCustom"));

var _useAddToCart = _interopRequireDefault(require("./hooks/useAddToCart"));

var _useViewProduct = _interopRequireDefault(require("./hooks/useViewProduct"));

var _useSearch = _interopRequireDefault(require("./hooks/useSearch"));

var _useAddToWishList = _interopRequireDefault(require("./hooks/useAddToWishList"));

var _useCompleteRegistration = _interopRequireDefault(require("./hooks/useCompleteRegistration"));

var _useBeginCheckout = _interopRequireDefault(require("./hooks/useBeginCheckout"));

var _usePurchase = _interopRequireDefault(require("./hooks/usePurchase"));

var _gqls = require("./gqls");

var _head = require("./gqls/head");

var _useFbq2 = require("./gqls/useFbq");

var _useRetention2 = require("./gqls/useRetention");

var _useAddToCart2 = require("./gqls/useAddToCart");

var _useViewProduct2 = require("./gqls/useViewProduct");

var _useSearch2 = require("./gqls/useSearch");

var _useCompleteRegistration2 = require("./gqls/useCompleteRegistration");

var _useBeginCheckout2 = require("./gqls/useBeginCheckout");

var _usePurchase2 = require("./gqls/usePurchase");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
// graphql import
// definition
var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _data$viewer;

  var children = _ref.children,
      pageId = _ref.pageId,
      snapshotId = _ref.snapshotId;

  var _useQuery = (0, _client.useQuery)(_gqls.getAdTrack),
      data = _useQuery.data;

  var store = (data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.store) || null;
  var adTracks = (store === null || store === void 0 ? void 0 : store.adTracks) || null;

  var _ref2 = (data === null || data === void 0 ? void 0 : data.viewer) || {},
      id = _ref2.id,
      _ref2$email = _ref2.email,
      email = _ref2$email === void 0 ? null : _ref2$email,
      role = _ref2.role,
      name = _ref2.name,
      mobile = _ref2.mobile,
      memberGroup = _ref2.memberGroup,
      segmentationTagCode = _ref2.segmentationTagCode;

  var user = {
    id: id,
    email: email,
    role: role,
    name: name,
    mobile: mobile,
    memberGroup: memberGroup,
    segmentationTagCode: segmentationTagCode
  };
  var fbq = (0, _useFbq["default"])({
    store: (0, _filter["default"])(_useFbq2.useFbqFragment, store),
    email: email
  });
  var custom = (0, _useCustom["default"])(fbq, {
    pageId: pageId,
    snapshotId: snapshotId
  });
  var addToCart = (0, _useAddToCart["default"])((0, _filter["default"])(_useAddToCart2.useAddToCartFragment, adTracks), fbq);
  var viewProduct = (0, _useViewProduct["default"])((0, _filter["default"])(_useViewProduct2.useViewProductFragment, adTracks), fbq);
  var search = (0, _useSearch["default"])((0, _filter["default"])(_useSearch2.useSearchFragment, adTracks), fbq);
  var addToWishList = (0, _useAddToWishList["default"])((0, _filter["default"])(_useAddToCart2.useAddToCartFragment, adTracks), fbq);
  var completeRegistration = (0, _useCompleteRegistration["default"])((0, _filter["default"])(_useCompleteRegistration2.useCompleteRegistrationFragment, store), fbq, email);
  var beginCheckout = (0, _useBeginCheckout["default"])((0, _filter["default"])(_useBeginCheckout2.useBeginCheckoutFragment, store), fbq, email);
  var purchase = (0, _usePurchase["default"])((0, _filter["default"])(_usePurchase2.usePurchaseFragment, store), fbq);
  (0, _useRetention["default"])({
    store: (0, _filter["default"])(_useRetention2.useRetentionFragment, store),
    fbq: fbq,
    pageId: pageId,
    snapshotId: snapshotId
  });
  var value = (0, _react.useMemo)(function () {
    return {
      custom: custom,
      addToCart: addToCart,
      viewProduct: viewProduct,
      search: search,
      addToWishList: addToWishList,
      completeRegistration: completeRegistration,
      beginCheckout: beginCheckout,
      purchase: purchase
    };
  }, [addToCart, addToWishList, beginCheckout, completeRegistration, custom, purchase, search, viewProduct]);
  if (!store) return /*#__PURE__*/_react["default"].createElement(_spin["default"], {
    indicator: /*#__PURE__*/_react["default"].createElement(_LoadingOutlined["default"], {
      spin: true
    })
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Head["default"], {
    user: user,
    store: (0, _filter["default"])(_head.headFragment, store),
    fbq: fbq
  }), /*#__PURE__*/_react["default"].createElement(_AdTrack["default"].Provider, {
    value: value
  }, children));
});

exports["default"] = _default;